import React from 'react';
import Badge from '../../../../components/Atoms/Badge';
import { useI18n } from '../../../../i18n';

// Job status -> badge variant + icon. Warnings on an otherwise-complete job
// downgrade it to the warning look, so "finished but produced 0 images" can
// never read as a clean success.
const STATUS_STYLE = {
  queued: { variant: 'neutral', icon: 'fa-clock' },
  inprogress: { variant: 'info', icon: 'fa-spinner' },
  complete: { variant: 'success', icon: 'fa-check' },
  partiallycomplete: { variant: 'warning', icon: 'fa-exclamation-triangle' },
  failed: { variant: 'danger', icon: 'fa-times' },
  cancelled: { variant: 'neutral', icon: 'fa-ban' },
};

const LABEL_KEY = {
  queued: 'queued',
  inprogress: 'inProgress',
  complete: 'complete',
  partiallycomplete: 'partiallyComplete',
  failed: 'failed',
  cancelled: 'cancelled',
};

const VideoJobStatusBadge = ({ status, hasWarnings = false }) => {
  const { t } = useI18n();
  const key = String(status || '').toLowerCase();
  const style = STATUS_STYLE[key] || { variant: 'neutral', icon: 'fa-question' };
  const labelKey = LABEL_KEY[key] || 'unknown';
  const variant = hasWarnings && style.variant === 'success' ? 'warning' : style.variant;

  return (
    <Badge variant={variant} icon={style.icon}>
      {t(`videoToImages.status.${labelKey}`)}
    </Badge>
  );
};

export default VideoJobStatusBadge;
